// Author Liang Gang Qiang
// Date 2022-03-14 16:19:41

class SithMesPrdToolsPackage {
constructor({
        id = null,
        code = '',
        name = '',
        type = '',
        status = '',
        seq = '',
        remark = ''}
= {}) {
    this.id = id;
    this.code = code;
    this.name = name;
    this.type = type;
    this.status = status;
    this.seq = seq;
    this.remark = remark;
}
}

function newEntity() {
return new SithMesPrdToolsPackage();
}

    function gridFields() {
    return Object.freeze([
        {
        key: 'id',
        label: 'label.sith.prd.sithMesPrdToolsPackage.grid.id',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'code',
        label: 'label.sith.prd.sithMesPrdToolsPackage.grid.code',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'name',
        label: 'label.sith.prd.sithMesPrdToolsPackage.grid.name',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'seq',
        label: 'label.sith.prd.sithMesPrdToolsPackage.grid.seq',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'remark',
        label: 'label.sith.prd.sithMesPrdToolsPackage.grid.remark',
        sortable: true,
            isDetail: true,
        form: {
        type: 'textarea',
        modalMultiSelectedType: 'string'
        }
        }
    ])}

const filter = {
    idFilter : '',
    idListFilter : [],
    codeFilter : '',
    nameFilter : '',
    typeFilter : '',
    statusFilter : '',
    seqFilter : ''
};

const fields = Object.freeze(Object.keys(newEntity()).map(i => 'entity.' + i));

const filterFields = Object.freeze(Object.keys(filter).map(i => 'filter.' + i));

const filterConfigs = [
        {
        key: 'codeFilter',
        label: 'label.sith.prd.sithMesPrdToolsPackage.filter.code',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'nameFilter',
        label: 'label.sith.prd.sithMesPrdToolsPackage.filter.name',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'seqFilter',
        label: 'label.sith.prd.sithMesPrdToolsPackage.filter.seq',
        disabled: false,
        form: {
        type: 'inputNumber',
        modalMultiSelectedType: 'string'
                }
        }
];


    const entityFormConfigs = [
        {
        key: 'code',
        label: 'label.sith.prd.sithMesPrdToolsPackage.entity.code',
        sortable: true,
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'name',
        label: 'label.sith.prd.sithMesPrdToolsPackage.entity.name',
        sortable: true,
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'seq',
        label: 'label.sith.prd.sithMesPrdToolsPackage.entity.seq',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'remark',
        label: 'label.sith.prd.sithMesPrdToolsPackage.entity.remark',
        sortable: true,
        disabled: false,
        form: {
        type: 'textarea',
        modalMultiSelectedType: 'string'
                }
        }
]

export {SithMesPrdToolsPackage, newEntity, gridFields, fields, filterFields, filter, entityFormConfigs
, filterConfigs


}
